import classNames from 'classnames';
import React, { useState } from 'react';
import { IconButton } from '~/ui';
import PT from 'prop-types';

import './detail-drawer-item.scss';

function DetailDrawerItem({
    title,
    isDividerDisabled = false,
    children,
    ...extra
}) {
    const [isOpen, setIsOpen] = useState(true);

    function showDetails() {
        setIsOpen(!isOpen);
    }

    function _getItemClassName() {
        const conditionalClasses = {
            'detail-drawer-item--open': isOpen
        };
        return classNames(
            'detail-drawer-item',
            conditionalClasses,
            extra.itemClassName
        );
    }

    function _getIconButtonClassName() {
        const defaultClassName = 'drawer-button';
        const conditionalClasses = {
            '_t-rotate-180': isOpen
        };
        return classNames(defaultClassName, conditionalClasses);
    }

    return (
        <div className={classNames(extra.className)}>
            {!isDividerDisabled && (
                <div className="detail-drawer-item__divider _mb-3" />
            )}
            <div
                className={_getItemClassName()}
                data-testid="detail-drawer-item"
            >
                <div className="_d-flex _jc-space-between _ai-center _mb-3">
                    <span className="heading-2">{title}</span>
                    <IconButton
                        className={_getIconButtonClassName()}
                        icon="chevronDown"
                        size="xs"
                        color="galaxy-800"
                        onClick={showDetails}
                        data-testid="chevronDown-icon"
                    />
                </div>
                <div
                    className="detail-drawer-item__body"
                    data-testid="detail-drawer-item__body"
                >
                    {children}
                </div>
            </div>
        </div>
    );
}

DetailDrawerItem.propTypes = {
    title: PT.string,
    children: PT.node
};

export default DetailDrawerItem;
